// extracted by mini-css-extract-plugin
export var animationContainer = "_jj-0";
export var footer = "_jj-1";
export var gray = "_jj-2";
export var lineItem = "_jj-3";
export var lineItemImage = "_jj-4";
export var lineItemInfo = "_jj-5";
export var lineItemText = "_jj-6";
export var lineItems = "_jj-7";
export var modalContent = "_jj-8";
export var options = "_jj-9";
export var orderName = "_jj-a";
export var refundAmount = "_jj-b";